import React from 'react';

export default function ForwardsAndBackwardsIcon({
  direction = 'right',
  onClick,
  disabled = false,
  label = direction === 'right' ? 'Next' : 'Back',
}) {
  const rotation = direction === 'left' ? 'rotate(180deg)' : 'none';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className="modal-nav-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transform: rotation }}
        className="modal-nav-icon"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 18l6 -6l-6 -6v12" />
      </svg>
    </button>
  );
}